import type { FC } from 'react';

import * as styles from './AvailableLabel.css';
import { FormattedMessage } from '../../utils';
import { useStoreCard } from '../StoreCardWrapper/StoreCardContext';

interface AvailableLabelProps {
  readonly align?: 'left' | 'center' | 'right';
}

export const AvailableLabel: FC<AvailableLabelProps> = ({ align = 'left' }) => {
  const { item } = useStoreCard();

  if (!item || item.type !== 'bundle') {
    return null;
  }

  const limits = 'limits' in item ? item.limits : null;
  const perUserLimit = limits?.perUser;

  if (!perUserLimit) {
    return null;
  }

  const available = perUserLimit.available ?? 1;
  const total = perUserLimit.total ?? 1;

  return (
    <div className={`${styles.container} ${styles[align]}`}>
      <FormattedMessage
        id='composer-club.available'
        values={{
          available,
          total,
        }}
      />
    </div>
  );
};
